module.exports = __webpack_public_path__ + "img/rating-icon-2.7e556715.svg";